import React, { Component } from "react";
import { withTranslation} from "react-i18next";
import swal from "sweetalert";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  withTheme,
} from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Loader from "../loaders/loader";
import {setactiveTabObj,} from "../../redux/actions/appActions";
import { connect } from "react-redux";
import ApiServices from "../../api/api";
import ServicesList from "./ServicesList";
import ReportList from './ReportList';
import ServiceForm from './ServiceForm';
import Listselect1 from './listselect1.js'
import OffileDb from '../../config/pouchDB';
import { gaLogEvent, gaLogScreen } from "../../helpers/analytics";
import { db } from "../../service/firebase"
import cordovaConfig from '../../config/cordovaConfig';
import { logError } from "../../helpers/auth";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class Services extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      serviceList: [],
      value: 0,
      caseReportList: [],
      caseOfflineReportList: [],
      offileReportIndex: 0,
      tabList: [],
      reportcategory: [],
      reportCatName: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);

  }

  componentDidMount() {
    gaLogEvent("Services", '', '');
    OffileDb.setDatabase()
    this.getTablist()
    this.checkActiveTab()
    this.loadOfflineData()
    // if (navigator.onLine) {
    //   this.getServicedDetails();
    // } else {
    //   this.loadOfflineData()
    // }
    cordovaConfig.init();
  }

  getTablist() {
    var menuList = JSON.parse(localStorage.getItem("menuList"));
    var tab = menuList.filter(obj => obj.path == 'services');
    if (tab && tab.length > 0) {
      console.log(tab[0].childs)
      this.setState({
        tabList: tab[0].childs.filter(obj => obj.isactive && obj.visible),
      });
    }
    // var self = this;
    // var myNotiRedPage = localStorage.getItem('notiRedPage');
    // if (myNotiRedPage) {
    //   myNotiRedPage = JSON.parse(myNotiRedPage);
    //   if (myNotiRedPage.page == '/layout/services') {
    //     self.handleChange(self, 1);
    //     localStorage.setItem('notiRedPage', '');
    //   }
    // }

  }

  checkActiveTab() {
    var activetab = JSON.parse(sessionStorage.getItem('activeTab'))
    if (activetab != null && activetab['service'] != undefined) {
      this.setState({
        value: activetab['service'],
      });
      this.getReportList();
    }
  }

  getReportList() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
        languageId: this.props.langId,
        selectedLanguage: parseInt(this.props.langId),
        userId: JSON.parse(localStorage.getItem('obj')).userId
      };

      ApiServices.getCaseListForService(param).then((res) => {
        console.log(res)
        try{
          if (res.data.status == 200) {
            this.setState({ caseReportList: res.data.data.caseList, isLoading: false });
            OffileDb.setData('serviceReportList', res.data.data.caseList)
            var tempArr = []
            Object.entries(res.data.data.caseList).forEach(entry => {
              const [key, value] = entry;
              if (!tempArr.includes(key)) {
                tempArr.push(key)
              }
            })
            console.log(tempArr)
            this.setState({ reportcategory: tempArr })
          }
          this.loadserviceOfflineReportList()
        }catch(err){
          console.log("err::", err)
          var errorObj = {
            component: 'Services',
            method: 'getReportList',
            error: err
          }
          logError(errorObj);
        }
      });
    } else {
      this.loadOfflineReportData()
    }
  }

  getServicedDetails() {
    var param = {
      communityId: this.props.communityuid,
      languageId: Number(this.props.langId),
      userId: JSON.parse(localStorage.getItem('obj')).userId
    };
    console.log(param)
    ApiServices.getServiceByCommunityId(param).then((res) => {
      try{
        console.log(res)
        if (res.data.data.length > 0) {
          this.setState({ serviceList: res.data.data, isLoading: false });
          OffileDb.setData('serviceList', res.data.data)
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  loadOfflineData() {
    var that = this
    OffileDb.getData('serviceList').then(function (result) {
      that.setState({
        isLoading: false
      });
      if (result.status && result.status == 404) {
        that.getServicedDetails()
      } else {
        that.setState({
          serviceList: result.data,
          isLoading: false
        });
      }
    });
  }

  loadOfflineReportData() {
    var that = this
    OffileDb.getData('serviceReportList').then(function (result) {
      if (result.status && result.status == 404) {
      } else {
        that.setState({
          caseReportList: result.data,
          isLoading: false
        });
        
      }
      that.loadserviceOfflineReportList()
    });
  }

  loadserviceOfflineReportList() {
    var that = this
    const { t } = this.props;
    var caseReportList = this.state.caseReportList
    var tablen = this.state.tabList.length
    OffileDb.getData('serviceOfflineReportList').then(function (result) {
      if (!result.status && result.status != 404) {
        if (result.data && result.data.length > 0) {
          caseReportList['offline'] = result.data
          that.setState({
            caseReportList: caseReportList,
            caseOfflineReportList: result.data,
            isLoading: false
          });
          if (navigator.onLine && that.state.value == 1) {
            swal({
              text: t("Offline data detected. Do you want to sync your responses?"),
              icon: "warning",
              buttons: {
                confirm: {
                  text: t("yes"),
                  value: true,
                  visible: true,
                  className: "",
                  closeModal: true
                },
                cancel: {
                  text: t("no"),
                  value: false,
                  visible: true,
                  className: "",
                  closeModal: true,
                }
              }
            }).then((val) => {
              console.log(val)
              if (val) {
                that.submitOfflineReport()
              }
            });
          }
        } else{
          //that.submitOfflineReport()
        }
      }
    })
  }

  submitOfflineReport() {
    const { t } = this.props;
    if (this.state.caseOfflineReportList && this.state.offileReportIndex != this.state.caseOfflineReportList.length) {
      this.submitReportToApiData(this.state.caseOfflineReportList[this.state.offileReportIndex])
    } else {
      swal({
        text: t("Data synced successfully"),
        icon: "success",
        button: t("ok"),
      }).then((val) => {
        this.getReportList()
        OffileDb.removeData('serviceOfflineReportList')
      });
    }
  }

  submitReportToApiData(params) {
    var self = this;
    var num = this.state.offileReportIndex + 1;
    ApiServices.addCaseForService(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.setState({ offileReportIndex: num })
          this.submitOfflineReport()
        }
      }catch(err){
        console.log("err::", err)
        var errorObj = {
          component: 'Services',
          method: 'submitReportToApiData',
          error: err
        }
        logError(errorObj);
      }
    });
  }

  handleChange(event, newValue) {
    this.setState({
      value: newValue,
      isLoading: true
    }, () => {
      this.getReportList();
    });
    //this.props.setactiveTabObj({'service': newValue})
    sessionStorage.setItem('activeTab', JSON.stringify({ 'service': newValue }))
  }

  handleChangeIndex(index) {
    this.setState({
      value: index,
      isLoading: true
    }, () => {
      this.getReportList();
    });
    sessionStorage.setItem('activeTab', JSON.stringify({ 'service': index }))
    //this.props.setactiveTabObj({'service': index})
  }

  getReportListHtml() {
    let reportList = []
    Object.entries(this.state.caseReportList).forEach(entry => {
      const [key, value] = entry;
      if (this.state.reportCatName != '') {
        if (this.state.reportCatName == key) {
          value.map(caseobj => {
            reportList.push(<ReportList key={caseobj.caseId} caseobj={caseobj} casetype={key.toLowerCase()} updateCaseList={() => this.getReportList()} />)
          })
        }
      } else {
        value.map(caseobj => {
          reportList.push(<ReportList key={caseobj.caseId} caseobj={caseobj} casetype={key.toLowerCase()} updateCaseList={() => this.getReportList()} />)
        })
      }

    })
    reportList =  reportList.sort((a,b) => b.key - a.key);
    //return reportList.reverse();
    return reportList
  }

  onOptionChange(val) {
    this.setState({ reportCatName: val })
  }


  render() {
    const { classes, theme } = this.props;
    const { t } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: `url(${this.state.background})` } : {};
    let reportList = this.getReportListHtml()
    // Object.entries(this.state.caseReportList).forEach(entry => {
    //   const [key, value] = entry;
    //   value.map(caseobj => {
    //     reportList.push(<ReportList caseobj={caseobj} casetype={key.toLowerCase()} updateCaseList={() => this.getReportList()} />)
    //   })
    // })



    if (this.state.isLoading) {
      reportList = <Loader isLoading={this.state.isLoading} />
    } else if (reportList && reportList.length == 0) {
      reportList = <h5>{t('No Record Found')}</h5>
    }


    return (
      <div className="gkdivcontent getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <AppBar className="tabheader" position="static" color="default" style={colorStyles}>
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor={templateID == 1 ? "primary" : "#fff"}
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            {
              this.state && this.state.tabList && this.state.tabList.length > 0 ? (
                this.state.tabList.map((tabListObj, index) => {
                  return (<Tab label={t(tabListObj.label)} {...a11yProps(index)} />)
                })
              ) : (<h5>{t('No Record Found')}</h5>)
            }
            {/* <Tab label={t('Report')} {...a11yProps(0)} />
            <Tab label={t('Response')} {...a11yProps(1)} /> */}
          </Tabs>
        </AppBar>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={this.state.value}
          onChangeIndex={this.handleChangeIndex}
          className="infotabcontainer getaccesstabspage getinvolvedtabsmainholder"
        >

          {this.state && this.state.tabList && this.state.tabList.length > 0 &&
            this.state.tabList.map((tabListObj, index) => {
              return (
                <TabPanel value={this.state.value} index={index} dir={theme.direction}>
                  {tabListObj.componentId == 30 || tabListObj.name == "report" ?
                    (
                      <div className={this.state && this.state.serviceList && this.state.serviceList.length > 1 ? "forumlistdivholder servicesList white_bg" : "forumlistdivholder servicesList"}>

                        {this.state && this.state.serviceList && this.state.serviceList.length > 0 ? (
                          this.state && this.state.serviceList && this.state.serviceList.length > 1 ? (
                            this.state.serviceList.map((serviceObj) => {
                              return <ServicesList serviceObj={serviceObj} languageId={this.props.langId} />;
                            })
                          ) : (
                            <ServiceForm tablist={this.state.tabList} inlineForm={true} serviceObj={this.state.serviceList[0]} handleChangeIndex={(i) => this.handleChangeIndex(i)}></ServiceForm>
                          )
                        ) : (<h5>{t('No Record Found')}</h5>)
                        }
                      </div>) : (
                      tabListObj.componentId == 31 || tabListObj.path == "response" ? (
                        <Grid
                          container
                          spacing={3}
                          className="gridcontainer case-report maplistcontainerdiv repostListContainer "
                        >
                          {
                            this.state && this.state.reportcategory && this.state.reportcategory.length > 0 &&
                            <Grid item xs={12} className="pb-0px pl-0px pr-0px">
                              <Listselect1 options={this.state.reportcategory} onOptionChange={(value) => { this.onOptionChange(value) }}></Listselect1>
                            </Grid>
                          }
                          {reportList}
                        </Grid>
                      ) : ('')
                    )
                  }
                </TabPanel>
              )
            })
          }
          {/* <TabPanel value={this.state.value} index={1} dir={theme.direction}>
            <Grid
              container
              spacing={3}
              className="gridcontainer case-report maplistcontainerdiv repostListContainer"
            >
              {reportList}
            </Grid>
          </TabPanel> */}
        </SwipeableViews>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    activeTabObj: storeState.activeTabObj,
    componentbgcolor: storeState.componentbgcolor
  };
};

// export default connect(mapStateToProps)(Services);

const transSerives = withTranslation()(Services);
const ThemeServices = withTheme(transSerives);
const FinalServices = withStyles(useStyles)(ThemeServices);
const routeServices = withRouter(FinalServices);
export default connect(mapStateToProps, { setactiveTabObj })(routeServices);
